import { httpClient, KEM_BACKEND_API_URL } from "@ch/api";
import localforage from "localforage";
import { StorageNamesEnum } from "@ch/helpers/utils/enums";

export interface TGenerateTextToAudioRequest {
  messageId: string;
  userId?: string;
}

export interface TGenerateTextToAudioResponse {
  output_audio_url: string;
}

const generateTextToAudio = async (req: TGenerateTextToAudioRequest) => {
  const refreshToken = await localforage.getItem<string>(
    StorageNamesEnum.REFRESH_TOKEN,
  );

  return httpClient<TGenerateTextToAudioResponse>({
    baseURL: KEM_BACKEND_API_URL,
    url: "/text-audio/",
    method: "GET",
    params: {
      message_id: req.messageId,
      user_id: req.userId,
    },
    headers: {
      "X-Token": refreshToken ?? "",
    },
  });
};

export default generateTextToAudio;
